<template>
  <div class="roleDisplay">
    <div class="roleList" v-for="(item,index) in roleList" :key="index">
      <!-- <div class="Imgcontent"> -->
      <img class="roeImg" :src="item.rphotograph" alt="名字">
      <!-- </div> -->
      <div class="person">{{item.rname}}</div>
    </div>
    <router-view />

  </div>
</template>

<script>
export default {
  data() {
    return {
     roleList:[]
    }
  },
    created() {
    this.rolesData();
  },

  methods: {
    //角色展示
    rolesData() {
      let self =this;
      // 发送 POST 请求
      this.$axios
        .post("http://8.129.62.150:8080/index/roles", {
          current: "1",
          size: "100"
        })
        .then(function(res) {
          self.roleList=res.data.data.list
        })
    },

    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
}
</script>

<style scoped>
.roleDisplay {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  background: #FFFFE6;
  border: 2px solid #89c33f ;
  margin: 5% 0;
  padding: 5%;
  color: #603813;
  font-size: 16px;
  font-weight: bold;
}
.roleList {
  display: flex;
  width: 30%;
  height: 50%;
  margin: 5% 1%;
}
/* .Imgcontent {
  width: 30%;
  height: 30%;
  background: #fff;
  border: 2px solid #89c33f ;
} */
.roeImg {
  width: 30%;
  height: 30%;
}

@media screen and (max-width: 700px) {
  .roeImg {
  width: 60%;
  height: 60%;
}
.roleList {
  display: flex;
  width: 40%;
  height: 60%;
  margin: 5% 1%;
}
.person {
  font-size: 16px;
}
}
</style>


// WEBPACK FOOTER //
// src/components/roleDisplay.vue